import { useEffect } from 'react';

/**
 * Hook to catch unhandled promise rejections and other async errors
 * that aren't caught by React error boundaries
 */
export const useGlobalErrorHandler = () => {
  useEffect(() => {
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('Unhandled promise rejection:', event.reason);
      
      // Check if it's an authentication error
      const reason = event.reason;
      if (reason?.status === 401 || reason?.status === 403) {
        // Let the axiosBaseQuery handle authentication errors
        return;
      }
      
      // You can show a toast notification or trigger a custom error handler here
      // For now, we'll just log it and prevent the default browser behavior
      event.preventDefault();
      
      // Optionally, you could trigger a custom error state or notification
      // showErrorNotification('An unexpected error occurred. Please try again.');
    };

    const handleError = (event: ErrorEvent) => {
      console.error('Global error:', event.error);
      
      // Handle global JavaScript errors
      // You could show a notification or trigger error reporting here
    };

    const handleTokenExpired = (event: CustomEvent) => {
      console.warn('Token expired event received:', event.detail);
      // The Authenticate component will handle the UI for this
    };

    // Add event listeners for unhandled errors
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleError);
    window.addEventListener('tokenExpired' as any, handleTokenExpired);

    // Cleanup event listeners on unmount
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleError);
      window.removeEventListener('tokenExpired' as any, handleTokenExpired);
    };
  }, []);
};

export default useGlobalErrorHandler;
